import { render, staticRenderFns } from "./KitchenSets.vue?vue&type=template&id=0ecc9f56&scoped=true&"
import script from "./KitchenSets.vue?vue&type=script&lang=js&"
export * from "./KitchenSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc9f56",
  null
  
)

export default component.exports